import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Book } from './Book'
import { Injectable } from '@angular/core';
import { ConfigData } from '../ConfigData'

@Injectable()
export class GoogleData {
    constructor(private http:HttpClient) {}

    private getVolume = (googleId:string):Promise<any> => {
        return this.http.get('https://www.googleapis.com/books/v1/volumes/' + googleId, {
            params: new HttpParams().set('key', ConfigData.data.googleApiKey)
        }).toPromise().catch((err) => {
            // probably not found - google returns HTTP 503 if not found
            console.error(err);
            return null;
        });
    }
    
    
    private bookCache:{ [googleId:string]: Promise<Book>; } = {};
    getBook(googleId:string):Promise<Book> {
        if (googleId in this.bookCache) {
            return this.bookCache[googleId];
        } else {
            var promise = this.getVolume(googleId).then((item:any):Book => {
                return item ? Book.fromItem(item) : null;
            });
            this.bookCache[googleId] = promise;
            promise.catch((err) => {
                delete this.bookCache[googleId]; 
            });
            return promise;
        }
    }
    
    async getGoogleBooksList (query:string, startIndex:number, maxResults:number):Promise<{books:Book[], totalItems:number}> {
        var result:any = await this.http.get('https://www.googleapis.com/books/v1/volumes', {
            params: new HttpParams()
                    .set('key', ConfigData.data.googleApiKey)
                    .set('q', query)
                    .set('startIndex', startIndex.toString())
                    .set('maxResults', maxResults.toString())
                    .set('showPreorders', 'true')
        }).toPromise();

        return {
            totalItems: result.totalItems || 0,
            books: (result.items || []).map((item) => Book.fromItem(item))
        }
    }


    static validGoogleId = /^[a-zA-Z0-9\-_]{10,15}$/;
    static validISBN = /^(\d[\-|\ ]?){10}$|^(\d[\-|\ ]?){13}$/
    ISBNOrGoogleIdIsValid(query) {
        return GoogleData.validGoogleId.test(query) || GoogleData.validISBN.test(query);
    }
    
    isValidISBN(query) {
        return GoogleData.validISBN.test(query);
    }
    
    googleIdLookups:{[isbn:string] : Promise<string>} = {};
    
    getGoogleIdFromISBN(ISBN:string):Promise<string> {
        ISBN = ISBN.replace(/[\-\ ]/g, '');
        if (this.googleIdLookups[ISBN]) {
            return this.googleIdLookups[ISBN];
        }
        
        var promise = this.http.get('/s/api/getGoogleIdFromISBN', {
            params: new HttpParams().set('ISBN', ISBN)
        }).toPromise().then((data:any) => {
            if (data.status && data.status === 'SUCCESS') {
                return data.googleId;
            } else {
                console.warn(data);
                return null;
            }
        }).catch(console.error);
        this.googleIdLookups[ISBN] = promise;
        
        return promise;
    };

    getGoogleKnowledgeGraph(id:string):Promise<any> {
        return this.http.get('https://kgsearch.googleapis.com/v1/entities:search', {
            params: new HttpParams()
                    .set('key', ConfigData.data.googleApiKey)
                    .set('ids', id)
        }).toPromise();
    }
    
}



// WEBPACK FOOTER //
// ./web/static/services/GoogleData/GoogleData.ts